<template>
  <b-card class="p-md-3">
    <p class="text-center">Enter the email addresses of the users you'd like to add, then choose the role they should
      have within your organization</p>
    <validation-observer #default="{handleSubmit}">
      <b-form @submit.prevent>
        <users-invite-inputs :user="user" />

        <b-row
          class="mt-2"
          align-h="between"
        >
          <b-col md="2">
            <b-button
              variant="outline-primary"
              class="btn-pill d-block d-md-inline-block mb-1 mb-md-0"
              tag="a"
              @click="$router.back()"
            >
              Discard
            </b-button>
          </b-col>
          <b-col
            md="2"
            class="text-right"
          >
            <submit-button v-bind="{submit,handleSubmit}" />
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import SubmitButton from '@/components/FormInputs/SubmitButton.vue'
import UsersInviteInputs from './UsersInviteInputs.vue'

export default {
  name: 'UsersInvite',
  components: { SubmitButton, UsersInviteInputs },
  props: {
    user: { type: Object, default: () => {} },
    submit: { type: Function, default: () => {} },
  },
}
</script>

<style>

</style>
